import { useCallback, useState } from "react";
import { QuestionResponse } from "../types";
import { useTranslations } from "../contexts/LanguageContext";

interface AnswerInputHookArgs {
    question?: QuestionResponse | null, 
    setErrorMessage: React.Dispatch<React.SetStateAction<string|null>>;
}

interface AnswerInputHookReturn {
    selectedAnswers: number[];
    setSelectedAnswers: React.Dispatch<React.SetStateAction<number[]>>;
    errorMessage?: string | null;
    onRadioChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onCheckboxChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
/**
 * Custom hook to manage the local state for user answers and input handlers.
 */
export const useAnswerInput = ({ setErrorMessage }: AnswerInputHookArgs): AnswerInputHookReturn => {
    const [selectedAnswers, setSelectedAnswers] = useState<number[]>([])
    const [errorMessage, setLocalErrorMessage] = useState<string | null>(null)
      const t = useTranslations();

    const finalSetErrorMessage = (msg: string | null) => {
        setLocalErrorMessage(msg);
        setErrorMessage(msg);
    };

     const onRadioChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedAnswers([Number(event.target.value)]);
        finalSetErrorMessage(null);
    }, []);

    const onCheckboxChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        const isChecked = event.target.checked;

        setSelectedAnswers((prevSelectedAnswers) => {
            const currentAnswers = Array.isArray(prevSelectedAnswers) ? prevSelectedAnswers : [];

            const updatedAnswers = isChecked
                ? [...currentAnswers, Number(value)]
                : currentAnswers.filter((uncheckAns) => uncheckAns !== Number(value));

            finalSetErrorMessage(updatedAnswers.length === 0 ? t("errorMsg_selectAnswer","Please Select an answer") : null);
            return updatedAnswers;
        });
    }, []);


        return {
        selectedAnswers,
        setSelectedAnswers,
        errorMessage: errorMessage,
        onRadioChange,
        onCheckboxChange,
    };
};